import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { BookableResourceTourService } from "src/app/core/onbservice/bookable-resource-tour/bookable-resource-tour.service";

export const TOUR_MODAL_PREFERENCE_KEY = "hxa_tour_modal_preference";
export type TourModalPreference = "showEveryTime" | "dontShowAgain";

@Component({
  selector: "app-tour-modal",
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    FormsModule,
    RouterLink,
    TranslateModule,
    MatDialogContent,
  ],
  templateUrl: "./tour-modal.component.html",
  styleUrl: "./tour-modal.component.scss",
})
export class TourModalComponent implements OnInit {
  preference: TourModalPreference = "showEveryTime";

  constructor(
    public dialogRef: MatDialogRef<TourModalComponent>,
    private bookableResourceTour: BookableResourceTourService,
  ) {}

  ngOnInit(): void {
    const stored = localStorage.getItem(
      TOUR_MODAL_PREFERENCE_KEY,
    ) as TourModalPreference | null;
    if (stored === "showEveryTime" || stored === "dontShowAgain") {
      this.preference = stored;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  onPreferenceChange(): void {
    localStorage.setItem(TOUR_MODAL_PREFERENCE_KEY, this.preference);
  }

  startBookableResourceTour(): void {
    this.bookableResourceTour.startTour();
    this.close();
  }

  /** Returns true if the tour modal should be shown when the user lands on the dashboard. */
  static shouldShowTourModal(): boolean {
    return localStorage.getItem(TOUR_MODAL_PREFERENCE_KEY) !== "dontShowAgain";
  }
}
